import { Component, Input, OnDestroy, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { INotificacaoSistemaAviso, isOpcaoNaoMostrarNovamenteHabilitada } from 'src/app/interfaces/notificacao-sistema/notificacao-sistema.interface';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-modal-aviso-notificacao',
  templateUrl: './modal-aviso-notificacao.component.html',
  styleUrls: ['./modal-aviso-notificacao.component.scss']
})
export class ModalAvisoNotificacaoComponent implements OnInit, OnDestroy {
  @Input() aviso: INotificacaoSistemaAviso;
  @Input() token: string;

  descricaoSanitizada!: SafeHtml | null;
  naoMostrarAvisoNovamenteMarcado = false;
  salvandoOcultacao = false;
  private newSubs: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    public translate: TranslateService,
    private sanitizer: DomSanitizer,
    private loginService: LoginService,
  ) { }

  ngOnInit(): void {
    this.descricaoSanitizada = this.sanitizer.sanitize(SecurityContext.HTML, this.aviso?.descricao || '');
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  get exibirOpcaoNaoMostrarNovamente(): boolean {
    return isOpcaoNaoMostrarNovamenteHabilitada(this.aviso);
  }

  close(): void {
    this.activeModal.dismiss();
  }

  confirmarEntendi(): void {
    if (this.exibirOpcaoNaoMostrarNovamente && this.naoMostrarAvisoNovamenteMarcado) {
      this.salvarOcultacaoAviso();
      return;
    }

    this.activeModal.close();
  }

  private salvarOcultacaoAviso(): void {
    if (!this.token || !this.aviso?.id || this.salvandoOcultacao) {
      return;
    }

    this.salvandoOcultacao = true;
    this.newSubs = this.loginService.ocultarAvisoNotificacao(this.token, this.aviso.id).subscribe(
      () => {
        this.salvandoOcultacao = false;
        this.activeModal.close({ ocultado: true });
      },
      () => {
        this.salvandoOcultacao = false;
        this.toastr.error(this.translate.instant('ERRO_OCULTAR_AVISO_NOTIFICACAO'), '', { timeOut: 5000, closeButton: true });
      }
    );
  }
}
